<script lang="ts" setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const slideData = ref(
  {
    id: '01',
    title: '编织产业的纽带',
    description: '构建县域经济全栈赋能生态',
    showButton: true,
    buttonText: '关于我们',
    imgs: 'https://static.idicc.cn/cdn/official/H5/home_top_bg.png',
  },
)

const jumpTo = () => {
  router.push({
    path: '/consultUsForm/consult',
    
  })
}
</script>

<template>
  <div class="view-container">
    <div class="w-full h-full bg-cover  bg-center bg-no-repeat pt-[80px]" :style="{ backgroundImage: `url(${slideData.imgs})` }">
      <div class="mt-5 text-white flex flex-col  w-full flex-wrap items-center justify-center">
        <div class="w-full ml-[32px]">
          <div class="flex items-center">
            <div class="text-[36px] font-bold">
              {{ slideData.title }}
            </div>
            <!-- 彩色字 -->
            <!-- <img
              src="https://static.idicc.cn/cdn/official/H5/home_AIR.png"
              mode="scaleToFill"
              class="w-[59px] h-[26px]"
            > -->
          </div>
          <div class="text-[28px] font-bold mt-2">
            {{ slideData.description }}
          </div>
          <div class="text-[24px] text-[#C7D3F9] mt-4">
            产业智库引领 · 数智平台支撑 · 招商网络助力 · 产发生态赋能
          </div>
          <div class="buttonTextIcon text-[26px] text-center leading-[50px] mt-6" @click="jumpTo">
            立即咨询
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.view-container {
  position: relative;
  width: 100%;
  height: 420px;
}
.buttonTextIcon {
  width: 160px;
  height: 50px;
  background:bottom / contain no-repeat url("https://static.idicc.cn/cdn/official/H5/home_btn_bg.png");
  background-size:100% 100%;
}
</style>
